var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',_vm._l((_vm.courses),function(course){return _c('b-col',{key:course._id,attrs:{"md":"6","lg":"4"}},[_c('courseCard',{attrs:{"course":course}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }